import { Injectable } from '@angular/core';
import { ApiService } from 'libs/common-lib/src/lib/providers/api/api.service';
import { map, catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

@Injectable()
export class PlatformChoiceService {
  constructor(private readonly apiService: ApiService) {}

  loadPlatformOptions(callbackFn) {
    this.apiService.get$('agent/v1/creation/platforms', {}).pipe(
      map(response => {
        callbackFn(response);
      }),
      catchError(error => {
        // handling error. for us, the list will be just empty
        callbackFn(error);
        return EMPTY;
      })
    );
  }
}
